import React, { FunctionComponent } from "react"
import { Box, FormHelperText, makeStyles, Theme } from "@material-ui/core"
import { RenderField } from "./RenderField"
import { SchemaField } from "../featuer-layer-settings/schema"
import { FieldHelpTooltip } from "./FieldHelpTooltip"
import { useFormContext } from "react-hook-form"

/** FeatureFields component props */
interface FeatureFieldsProps {
  fields: SchemaField[] | undefined
}

/** Scoped @material-ui/core stylesheet */
const useStyles = makeStyles<Theme>(theme => ({
  helperText: {
    fontSize: 12,
    marginTop: 0,
  },
}))

/** Probably unnecessary component, but good for keeping concerns separate. */
export const FeatureFields: FunctionComponent<FeatureFieldsProps> = ({
  fields,
}) => {
  /** Get scoped CSS classes */
  const classes = useStyles()

  /** Hook up errors to the form */
  const { errors } = useFormContext()

  return (
    <>
      {fields?.map((field: SchemaField) => (
        <Box key={field.name} mb={2}>
          <RenderField field={field} />
          <Box display="flex" mt={0.5}>
            <FieldHelpTooltip title={field.description || ""} />
            <Box ml="auto">
              <FormHelperText
                error={Boolean(errors[field.name || ""])}
                className={classes.helperText}
              >
                {errors[field.name || ""]?.type === "required" && "Required"}
              </FormHelperText>
            </Box>
          </Box>
        </Box>
      ))}
    </>
  )
}
